module.exports = __webpack_public_path__ + "static/media/minarrow.e138dddc.svg";